export const state = {
  uid: '',
  name: '',
  email: '',
  picture: '',
  signInMethod: '',
  customerName: '',
  customerSetting: {
    customerId: null,
    country: '',
    externalServiceId: null,
    phone: '',
    postCode: '',
    purchaseType: '',
    representativeUserName: '',
    address: ''
  },
  selectedCustomer: {
    name: '',
    customerId: null,
    country: '',
    externalServiceId: null,
    phone: '',
    postCode: '',
    purchaseType: '',
    representativeUserName: '',
    address: ''
  },
  licenseList: [],
  role: 'Member',
  isAbejaAdmin: false,
  isNewUser: false,
  accessToken: '',
  refreshToken: '',
}
